import { render, staticRenderFns } from "./requirementForm.vue?vue&type=template&id=1d889c8c&"
import script from "./requirementForm.vue?vue&type=script&lang=js&"
export * from "./requirementForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports